module.exports = __webpack_public_path__ + "static/WebStructure-b70dcbe7477761c25c3834a1fed49451.png";